import React, { ReactNode } from 'react';

interface PageSectionProps {
  title: string;
  emoji?: string;
  children: React.ReactNode;
  className?: string;
  actions?: React.ReactNode;
  description?: string;
}

const PageSection: React.FC<PageSectionProps> = ({ 
  title, 
  emoji, 
  children, 
  className = '', 
  actions,
  description 
}) => {
  return (
    <div className={`bg-white rounded-lg shadow p-6 mb-6 ${className}`}>
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <div className="flex items-center space-x-2 mb-2 min-h-[2rem]">
            {emoji && <span role="img" aria-label={title.toLowerCase()} className="text-2xl flex-shrink-0">{emoji}</span>}
            <h2 className="text-2xl font-bold text-gray-900 leading-tight">{title}</h2>
          </div>
          {description && (
            <p className="text-gray-600">{description}</p>
          )}
        </div>
        {actions && <div className="flex-shrink-0 ml-4">{actions}</div>}
      </div>
      {children}
    </div>
  );
};

export default PageSection; 